const hasSMEModules = currentPolicy =>
  currentPolicy &&
  currentPolicy.SMEModules &&
  currentPolicy.SMEModules.length > 0;

export const shouldShowIfAllSMEModulesMatch = (
  currentPolicy,
  modulesToMatchOn
) =>
  hasSMEModules(currentPolicy) &&
  currentPolicy.SMEModules.every(smeModule =>
    modulesToMatchOn.some(moduleToCheck => moduleToCheck === smeModule)
  );

export const shouldShowIfAllSMEModulesDontMatch = (
  currentPolicy,
  modulesToMatchOn
) => !shouldShowIfAllSMEModulesMatch(currentPolicy, modulesToMatchOn);

export const shouldShowIfAnySMEModulesMatch = (
  currentPolicy,
  modulesToMatchOn
) =>
  hasSMEModules(currentPolicy) &&
  currentPolicy.SMEModules.some(smeModule =>
    modulesToMatchOn.some(moduleToCheck => moduleToCheck === smeModule)
  );
